import(/* webpackMode: "eager", webpackExports: ["NewsListSection"] */ "/var/www/SOC/src/sections/news-details/index.tsx");
